var map = {
	"./1.svg": 363,
	"./10.svg": 364,
	"./2.svg": 365,
	"./3.svg": 366,
	"./4.svg": 367,
	"./5.svg": 368,
	"./6.svg": 369,
	"./7.svg": 370,
	"./8.svg": 371,
	"./9.svg": 372
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/level_icons ^\.\/.*\.svg$
// module id = 154
// module chunks = 4